import BaseModelFactory from './base.factory'
import MessageService from './../services/Message.service'
import Message from './../models/message.model'

class MessageFactory extends BaseModelFactory {
  static search = async ({ search, pagination, order_by, method }) =>
    await this._search({ search, pagination, order_by, method }, { Service: MessageService, Model: Message })
  static findById = async id => await this._findBy({ id }, { Service: MessageService, Model: Message })
  static findAllById = async id => await this._findAllBy({ id }, { Service: MessageService, Model: Message })
  static findAllByCategory = async category =>
    await this._findAllBy({ category }, { Service: MessageService, Model: Message })
  static create = payload => this._create(payload, { Service: MessageService, Model: Message })
}

export default MessageFactory
